import {
    Edit,
    FormDataConsumer,
    NullableBooleanInput,
    SimpleForm,
    TextInput,
    useRecordContext,
} from 'react-admin';

import { EditToolbar } from '../../common/EditToolbar';
import FileUpload from '../../common/inputs/FileUpload';
import { PdfCategoryFilterInput } from './PdfsList';

const PdfEdit = () => (
    <Edit title={<PdfTitle />}>
        <SimpleForm toolbar={<EditToolbar />}>
            <FileUpload
                type="VIDEO_THUMBNAIL"
                required={true}
                label="select thumbnail"
                source="thumbnail"
                accept="image/*"
                multiple={false}
            />
            <TextInput source="title" fullWidth />
            <FormDataConsumer>
                {({ formData }) => {
                    return (
                        <FileUpload
                            type="PDF_NOTES"
                            required={true}
                            source="url"
                            label="select Pdf"
                            accept="application/pdf"
                            multiple={false}
                        />
                    );
                }}
            </FormDataConsumer>
            <PdfCategoryFilterInput />
            <NullableBooleanInput source="isDownloadable" fullWidth label={'Downloadable'} />
        </SimpleForm>
    </Edit>
);

const PdfTitle = () => {
    const record = useRecordContext<any>();
    return record ? <span>{record?.name || record?.title}</span> : null;
};

export default PdfEdit;
